export type BuildAuthorHrefInput = {
  readonly slug?: string | null;
  readonly url?: string | null;
  readonly isActive?: boolean | null;
  /** @deprecated Use isActive. */
  readonly isPublished?: boolean | null;
};

/**
 * Builds a public media-author URL when the author is active and has a slug or url.
 */
export function buildAuthorHref(input: BuildAuthorHrefInput): string | null {
  const isClickable = input.isActive ?? input.isPublished;
  if (!isClickable) {
    return null;
  }
  if (input.url?.trim()) {
    return input.url.trim();
  }
  if (!input.slug?.trim()) {
    return null;
  }
  return `/media/authors/${input.slug.trim()}`;
}
